import AssetDashboard from 'components/assets/asset/asset-dashboard';
import AssetRequestForm from 'components/service-requests/asset-request/asset-request-form';
import AssetTabs from 'components/assets/asset/asset-tabs/asset-tabs';
import Authorize from 'components/common/authorize';
import Breadcrumbs from 'components/common/breadcrumbs';
import CatchErrors from 'components/common/catch-errors';
import CustomerDashboard from 'components/customers/customer/customer-dashboard';
import CustomerForm from 'components/customers/customer/customer-form/customer-form';
import CustomerTabs from 'components/customers/customer/customer-tabs/customer-tabs';
import DashboardLayout from './layout/dashboard-layout';
import DashboardOverview from 'components/dashboard/overview/dashboard-overview';
import EditTimeClock from 'components/time-clock/edit-timeclock';
import GenerateInvoiceForm from "components/invoices/generate-invoice-form/generate-invoice-form";
import InvoiceDashboard from 'components/invoices/invoice/invoice-dashboard';
import LineItems from 'components/line-items/line-items-tab/line-items';
import PaymentDashboard from "components/payments/payment-dashboard";
import PaymentLinkModal from 'components/invoices/invoice/payment-link-modal';
import QuoteDashboard from 'components/quotes/quote/quote-dashboard';
import QuoteForm from 'components/quotes/quote/quote-form/quote-form';
import QuoteTabs from 'components/quotes/quote/quote-tabs';
import React, { useRef, useEffect, useState } from 'react';
import ReceivePaymentForm from 'components/payments/payment-form/receive-payment-form';
import ResultsActionModal from 'components/dashboard/results/results-actions/results-action-modal';
import ServiceRequestDashboard from 'components/service-requests/service-request/service-request-dashboard';
import ServiceRequestForm from 'components/service-requests/service-request/service-request-form/service-request-form';
import ServiceRequestTabs from 'components/service-requests/service-request/service-request-tabs';
import SlidingColumn from 'components/common/sliding-column';
import SlidingColumns from 'components/common/sliding-columns';
import SplitWorkOrderForm from 'components/work-orders/work-order/split-work-order-form/split-work-order-form';
import TimeClock from 'components/time-clock/time-clock';
import WorkOrderDashboard from 'components/work-orders/work-order/work-order-dashboard';
import WorkOrderForm from 'components/work-orders/work-order/work-order-form/work-order-form';
import WorkOrderTabs from 'components/work-orders/work-order/work-order-tabs';
import { APPS, PERMISSIONS } from 'components/constants';
import { Route, useParams, useRouteMatch, Switch } from 'react-router-dom';
import { VirtualKeyboardSupport } from 'components/test/virtual-keyboard-support';
import { numPanels } from 'components/common/toolbox';
import { useSelector } from 'react-redux';

export default function Dashboard(props) {
	
	const match = useRouteMatch();
    const params = useParams();
	const column2Ref = useRef(); // passed to FAB for scroll detection
	const column3Ref = useRef(); // passed to FAB for scroll detection

	const admin = useSelector((store) => store.admin);

	const [focusedInputCol2, setFocusedCol2] = useState(null);
	const [columnState, setColumnState] = useState(); // set by SlidingColumns

	// Depending on how many panels are showing (1-3) the array indicates # of segments at which a shift occurs up to 3 shifts
	const panelBP = {
		panels2: [99, 99, 99],
		panels1: [8, 11, 99],
	}

	// Show name in breadcrumb string if number of segments is at least "segments" and path contains optional "includes"
	const breadcrumbBP = [
		{ name: 'DASHBOARD' },
		{ name: 'Details', segments: 8 },
		{ name: 'Service Request', segments: 9, includes: 'service_requests' },
		{ name: 'Work Order', segments: 11, includes: 'work_orders' },
		{ name: 'Quote', segments: 11, includes: 'quotes' },
		{ name: 'Invoice', segments: 11, includes: 'invoices' },
	];

	const entity_id = (params.appId == APPS.DISPATCH.id) ? 'customer_id' : 'asset_id';

	return (
		<>
			<Breadcrumbs breakpoints={breadcrumbBP} columnState={columnState} />

			<SlidingColumns breakpoints={panelBP} setColumnState={setColumnState}>

				{/* --------------------------------------------------------------------------
					COLUMN 1
				--------------------------------------------------------------------------- */}

				<Switch>
					<Route exact path={`${match.path}/:widget_id/overview/mobile/:tab/:id?`} render={(route_props) => (
						<Authorize perm={ PERMISSIONS.ANALYTICS_DASHBOARD }>
							<SlidingColumn index={ 1 } columnState={ columnState } { ...route_props }>
								<CatchErrors>
									<DashboardOverview />
								</CatchErrors>
							</SlidingColumn>
						</Authorize>
					)} />
					<Route path={`${match.path}/:widget_id/:${entity_id}?/:form?/:form_id?/:tab1?/:tab1_id?/:tab2?/:tab2_id?/:tab3?/:preview?/:tab3_id?`} render={(route_props) => (
						<SlidingColumn index={ 1 } columnState={ columnState } { ...route_props }>
							<Authorize perm={ PERMISSIONS.TIMECLOCK_VIEW }>
								<CatchErrors>
									<TimeClock />
								</CatchErrors>
							</Authorize>
							<CatchErrors>
								<DashboardLayout />
							</CatchErrors>
						</SlidingColumn>
					)} />
				</Switch>

				{/* --------------------------------------------------------------------------
					COLUMN 2
				-------------------------------------------------------------------------- */}

				<Switch>
					<Route exact path={`${match.path}/:widget_id/0/overview/:tab?/:id?`} render={(route_props) => (
						<Authorize perm={ PERMISSIONS.ANALYTICS_DASHBOARD }>
							<SlidingColumn index={ 2 } columnState={ columnState } { ...route_props }>
								<CatchErrors>
									<DashboardOverview />
								</CatchErrors>
							</SlidingColumn>
						</Authorize>
					)} />
					<Route path={`${match.path}/:widget_id/:${entity_id}/:form/:form_id/:tab`} render={(route_props) =>
						<Authorize permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] } show403>
							<SlidingColumn index={ 2 } columnState={ columnState } columnRef={ (window.flutter) ? null : column2Ref }>
								<VirtualKeyboardSupport
									col={ 2 }
									columnRef={ (window.flutter) ? column2Ref : null }
									focusedInput={(window.flutter) ? focusedInputCol2 : null}
									virtualKeyboard={admin.flutter_keyboard}
									container_margin={ (window.flutter) ? 80 : numPanels(1) ? 140 : null }
									platform={admin.flutter_platform}
								>
									<CatchErrors>
										{ params.appId == APPS.DISPATCH.id
											?	<CustomerDashboard columnRef={ column2Ref } />
											:	<AssetDashboard columnRef={ column2Ref } />
										}
									</CatchErrors>

									<Switch>
										<Route path={`${match.path}/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/:tab?/:tab_id?`} render={(route_props) =>
											<Authorize permKeys={ [PERMISSIONS.SERVICE_REQUESTS_VIEW.key, PERMISSIONS.SERVICE_REQUESTS_ASSIGNED_VIEW.key] } show403>

												<CatchErrors className={'m-t-lg'}>
													<ServiceRequestDashboard columnRef={ column2Ref } {...route_props} source="dashboard" />
												</CatchErrors>

												<Switch>
													{/* These routes are for Work Order instances */}
													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/work_orders/:work_order_id/invoices/preview/:invoice_id`} render={(route_props) => (
														<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW } show403>
															<CatchErrors className={'m-t-lg'}>
																<InvoiceDashboard {...route_props} columnRef={ column2Ref } setFocused={ setFocusedCol2 } />
																<LineItems {...route_props} source={'invoices'} setFocused={ setFocusedCol2 } />
															</CatchErrors>
														</Authorize>
													)} />
													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/work_orders/:work_order_id/payments/preview/:payment_id`} render={(route_props) =>
														<Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_VIEW } show403>
															<CatchErrors className={'m-t-lg'}>
																<PaymentDashboard {...route_props} isPayment={true} />
															</CatchErrors>
														</Authorize>
													} />
													{/* ----------------------------------------- */}

													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/work_orders/:work_order_id/:tab/:action?/:action_id?`} render={(route_props) =>
														<Authorize permKeys={ [PERMISSIONS.WORK_ORDERS_VIEW.key, PERMISSIONS.WORK_ORDERS_ASSIGNED_VIEW.key] } show403>
															<CatchErrors className={'m-t-lg'}>
																<WorkOrderDashboard columnRef={ column2Ref } {...route_props} source="dashboard" />
															</CatchErrors>
															<CatchErrors className={'m-t-lg'}>
																<WorkOrderTabs {...route_props} source="service_requests" setFocused={ setFocusedCol2 } />
															</CatchErrors>
														</Authorize>
													} />
													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/quotes/:quote_id/:tab/:action?/:action_id?`} render={(route_props) =>
														<Authorize feature={'generate_quotes'} permKeys={ [PERMISSIONS.QUOTES_VIEW.key, PERMISSIONS.QUOTES_CREATE.key] } show403>
															<CatchErrors className={'m-t-lg'}>
																<QuoteDashboard {...route_props} />
															</CatchErrors>
															<CatchErrors className={'m-t-lg'}>
																<QuoteTabs {...route_props} setFocused={ setFocusedCol2  } />
															</CatchErrors>
														</Authorize>
													} />
													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:tab/:request_id/invoices/preview/:invoice_id/:invoice_tab?`} render={(route_props) => (
														<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW } show403>
															<CatchErrors className={'m-t-lg'}>
																<InvoiceDashboard {...route_props} columnRef={ column2Ref } setFocused={ setFocusedCol2 } />
																<LineItems {...route_props} source={'invoices'} setFocused={ setFocusedCol2 } />
															</CatchErrors>
														</Authorize>
													)} />
													<Route path={`/:handle/:appId/:widget_id/:${entity_id}/:form/:form_id/:service_filter/:request_id/payments/preview/:payment_id`} render={(route_props) =>
														<Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_VIEW } show403>
															<CatchErrors className={'m-t-lg'}>
																<PaymentDashboard {...route_props} isPayment={true} />
															</CatchErrors>
														</Authorize>
													} />
													{/* Default to tabs if no specific route is matched */}
													<CatchErrors className={'m-t-lg'}>
														<ServiceRequestTabs {...route_props} setFocused={ setFocusedCol2 } />
													</CatchErrors>
												</Switch>
											</Authorize>
										} />
										<CatchErrors>
											{ params.appId == APPS.DISPATCH.id
												?	<CustomerTabs {...route_props} />
												:	<AssetTabs {...route_props} />
											}
										</CatchErrors>
									</Switch>

								</VirtualKeyboardSupport>
							</SlidingColumn>
						</Authorize>			
					} />
				</Switch>

				<div id="column2-rel" className="col-lg-6 col-xl-4" style={{ pointerEvents: 'none' }}></div>

				{/* --------------------------------------------------------------------------
					COLUMN 3 
				-------------------------------------------------------------------------- */}

				{/* ----------------------------------------------------------------------------------------
					COLUMN 4
				----------------------------------------------------------------------------------------- */}


				{/* ----------------------------------------------------------------------
					MODALS
				---------------------------------------------------------------------- */}

				<Route path={`${match.path}/:widget_id/action-form/:entity/:entity_id/:action_id`} render={(route_props) =>
					<CatchErrors modal={true}>
						<ResultsActionModal {...route_props} />
					</CatchErrors>
				} />
                <Route path={`${match.path}/:widget_id/:${entity_id}/request-form/:request_id/:tab/:action?`} render={(route_props) =>
					<CatchErrors modal={true}>
						{ (params.appId == APPS.DISPATCH.id)
							?	<ServiceRequestForm {...route_props} />
							:	<AssetRequestForm {...route_props} type="asset_request"/>
						}
					</CatchErrors>
                } />

				<Route path={`${match.path}/:widget_id/:${entity_id}/customer-form/:profile_form_id?`} render={(route_props) => (
					<Authorize perm={ PERMISSIONS.CUSTOMERS_EDIT }>
						<CatchErrors modal={true}>
							<CustomerForm {...route_props} />
						</CatchErrors>
					</Authorize>
				)} />


                <Route path={`${match.path}/:widget_id/:${entity_id}/work-order-form/:work_order_id/:service_filter/:request_id`} render={(route_props) =>
					<CatchErrors modal={true}>
						<WorkOrderForm {...route_props} />
					</CatchErrors>
                } />
				<Route path={`${match.path}/:widget_id/:${entity_id}/split-work-order/:work_order_id/:service_filter/:request_id`} render={(route_props) =>
					<CatchErrors modal={true}>
						<SplitWorkOrderForm {...route_props} />
					</CatchErrors>
				} />
				<Route path={`${match.path}/:widget_id/:${entity_id}/invoice-form/:invoice_id/:service_filter/:request_id`} render={(route_props) =>
					<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_EDIT }>
						<CatchErrors modal={true}>
							<GenerateInvoiceForm {...route_props} />
						</CatchErrors>
					</Authorize>
				} />
				<Route path={`${match.path}/:widget_id/:${entity_id}/:form/:form_id/:tab/:request_id/invoices/preview/:invoice_id/payment`} render={(route_props) =>
					<Authorize feature={'generate_invoices'} perm={ PERMISSIONS.INVOICES_VIEW }>
						<CatchErrors modal={true}>
							<PaymentLinkModal {...route_props} />
						</CatchErrors>
					</Authorize>
				} />
                <Route path={`${match.path}/:widget_id/:${entity_id}/payment-form/:payment_id/:tab?/:request_id?/:request_tab/:preview?/:invoice_id?`} render={(route_props) =>
					<Authorize feature={'manage_payments'} perm={ PERMISSIONS.PAYMENTS_RECEIVE }>
						<CatchErrors modal={true}>
							<ReceivePaymentForm {...route_props} />
						</CatchErrors>
					</Authorize>
                } />
                <Route path={`${match.path}/:widget_id/:${entity_id}/quote-form/:quote_id/:tab?/:request_id?`} render={(route_props) =>
					<CatchErrors modal={true}>
						<QuoteForm />
					</CatchErrors>
                } />
				<Route path={`${match.path}/:widget_id/:${entity_id}/time-clock/:startdate/:enddate`} render={(route_props) => (
					<Authorize perm={ PERMISSIONS.TIMECLOCK_EDIT }>
						<CatchErrors modal={true}>
							<EditTimeClock {...route_props} />
						</CatchErrors>
					</Authorize>
				)} />

			</SlidingColumns>
		</>
	);
};
